import dayjs from "dayjs";
import { convertPermissionsToBitmask } from "./convertToBitmasks";
import { convertPlatformsToBitmask } from "./convertToBitmasks";
import moment from "moment-timezone";
import { extractColorValue } from "./extractColorValue";

const reunionsList = [
  {
    name: "Puryear Family Reunion",
    id: 8192,
  },
  {
    name: "Duncan Family Reunion",
    id: 15,
  },
  {
    name: "Rice Family Reunion",
    id: 1048576,
  },
  {
    name: "Baker Family Reunion",
    id: 16,
  },
  {
    name: "Whalen Family Reunion",
    id: 17,
  },
];

export function flattenFeedItemForPost({
  feedItem,
  diamondsList,
  groupsList,
  isDraft = false,
}) {
  // console.log("feedItem in flattenFeedItemForPost: ", feedItem);
  const findDiamondsIbos = (array) => {
    // console.log(array, feedItem)
    const ibos = [];
    array.map((string) => {
      ibos.push(diamondsList.find((diamond) => diamond.name == string).IBO);
    });
    return ibos;
  };
  const findGroupsIbos = (array) => {
    // console.log(array, feedItem)
    const groupId = [];
    array.map((string) => {
      groupId.push(groupsList.find((group) => group.name == string).groupId);
    });
    return groupId;
  };
  const findReunionsIbos = (array) => {
    const ibos = [];
    array.map((string) => {
      ibos.push(reunionsList.find((reunion) => reunion.name == string).id);
    });
    return ibos;
  };

  if (!feedItem || typeof feedItem !== "object") {
    throw new Error(
      "Invalid or undefined feedItem passed to flattenFeedItemForPut"
    );
  }

  const {
    options = {},
    data = {},
    information = {},
    content = {},
    type = "",
    template = "",
  } = feedItem;

  const today = moment().hour(17).minute(0).second(0).millisecond(0).toDate();

  const defaultFields = {
    unpublishType: "",
    group: 1,
    pinLevelPermissions: "",
    platforms: "",
    priority: "",
    status: "",
    template: "",
    title: "",
    previewIBO: "",
    managementApproved: "",
    diamonds: [],
    groups: [],
    familyReunions: [],
  };

  const sharedPayload = {
    ...defaultFields,
    ...options,
    id: 0,
    availableOn: options.availableOn || today,
    unpublishOn: options.unpublishOn || null,
    unpublishType: options.unpublishType || 0,
    pinLevelPermissions: convertPermissionsToBitmask(
      options.pinLevelPermissions || [
        "AssociateIbo",
        "Platinum",
        "Emerald",
        "Diamond",
      ]
    ),
    platforms: convertPlatformsToBitmask(
      options.platforms || ["Web", "iOS", "Android"]
    ),
    priority: options.priority || 0,
    status: options.status || 0,
    previewIBO: Number(options.previewIBO || 0),
    previewIbo: Number(options.previewIBO || options.previewIbo || 0),
    managementApproved: options.managementApproved || false,
    shouldSendUpdateIcon: options.shouldSendUpdateIcon ?? true,
    familyReunions: findReunionsIbos(options.familyReunions),
    diamonds: findDiamondsIbos(options.diamonds),
    groups: findGroupsIbos(options.groups),
    isEditingDraft: isDraft,
    // originalVersion: null,
  };

  if (type === "Standing Order") {
    return {
      ...sharedPayload,
      data: {
        card: {
          gradient: { ...data?.card?.gradient },
          header: { ...data?.card?.header },
          image: { ...data?.card?.image },
          details: { ...data?.card?.details },
          content: { ...data?.card?.content },
        },
      },
      template: "standing-order",
      title: sharedPayload.title || "* Standing Order Title *",
      group: 1,
    };
  }

  if (type === "Standard Content") {
    // console.log(sharedPayload);
    // Needs auditing. All data comes from information object. should be spread out and placed within objects correctly
    // --- Also needs done In flattenFeedItemForPut & flattenFeedItemForAuPost &
    const parseAngle = (val) => {
      if (val == null) return 0;
      if (typeof val === "string")
        return Number(val.replace(/deg\s*$/i, "")) || 0;
      return Number(val) || 0;
    };

    const gradientStops =
      information?.gradientColors && Array.isArray(information.gradientColors)
        ? information.gradientColors.map((c) => ({
            color: extractColorValue(c, "#FFFFFF"),
          }))
        : information?.card?.gradient?.stops || [
            { color: "#FFFFFF" },
            { color: "#FFFFFF" },
          ];

    const cardObj = {
      gradient: {
        angle: parseAngle(
          information?.gradientAngle || information?.card?.gradient?.angle
        ),
        stops: gradientStops,
      },
      header: {
        // topTitle should come from information.header
        topTitle: {
          text:
            information?.header ??
            information?.card?.header?.topTitle?.text ??
            "",
          color: extractColorValue(
            information?.headerTextColor ||
              information?.card?.header?.topTitle?.color,
            "#FFFFFF"
          ),
        },
        // main title: prefer options.title (form Title field), fallback to card header title
        title: {
          text: options?.title ?? information?.card?.header?.title?.text ?? "",
          color: extractColorValue(
            information?.titleTextColor ||
              information?.card?.header?.title?.color,
            "#000000"
          ),
        },
        subTitle: {
          text:
            information?.subHeader ??
            information?.card?.header?.subTitle?.text ??
            "",
          color: extractColorValue(
            information?.subHeaderTextColor ||
              information?.card?.header?.subTitle?.color,
            "#FFFFFF"
          ),
        },
      },
      image: {
        alignment:
          information?.horizontalAlign ||
          information?.card?.image?.alignment ||
          "center",
        path:
          information?.imgSrc ||
          information?.card?.image?.path ||
          feedItem?.imgSrc ||
          "",
        verticalAlignment:
          information?.verticalAlign ||
          information?.card?.image?.verticalAlignment ||
          "middle",
        subText: information?.card?.image?.subText ?? {
          text: "",
          color: "#000000",
        },
        maxHeight:
          information?.maxHeight ?? information?.card?.image?.maxHeight ?? "",
      },
      details: information?.card?.details ??
        information?.details ?? {
          creator: { text: "", color: "#FFFFFF" },
          sku: { text: "", color: "#FFFFFF" },
          title: { text: "", color: "#000000" },
        },
    };
    // Build top-level fields expected by mapFeedItems.js so the UI can
    // rehydrate the same shape when reading the API response.
    const makeAngleString = (raw) => {
      if (raw == null) return "0deg";
      if (typeof raw === "string")
        return raw.match(/deg\s*$/i) ? raw : `${raw}deg`;
      return `${Number(raw) || 0}deg`;
    };

    const {
      card: _omitCard,
      content: _omitContent,
      ...otherInformation
    } = information || {};

    const topLevel = {
      backgroundType: information?.backgroundType ?? "On Gradient",
      bottomPadding: information?.bottomPadding ?? true,
      gradientAngle: makeAngleString(
        information?.gradientAngle || information?.card?.gradient?.angle
      ),
      gradientColors:
        information?.gradientColors || gradientStops.map((s) => s.color),
      header: information?.header ?? cardObj.header?.topTitle?.text ?? "",
      headerBackground: information?.headerBackground ??
        information?.card?.headerBackground ?? {
          backgroundColor: "default",
          backgroundOpacity: "0.80",
        },
      headerTextColor:
        information?.headerTextColor ??
        information?.card?.header?.topTitle?.color ??
        "default",
      horizontalAlign:
        information?.horizontalAlign ?? cardObj.image.alignment ?? "center",
      imgSrc:
        information?.imgSrc ?? cardObj.image.path ?? feedItem?.imgSrc ?? "",
      maxHeight: information?.maxHeight ?? cardObj.image.maxHeight ?? "",
      subHeader: information?.subHeader ?? "",
      subHeaderTextColor: information?.subHeaderTextColor ?? "default",
      draftVersion: information?.draftVersion ?? null,
      ...otherInformation,
    };

    const contentSections =
      content?.sections ??
      information?.content?.sections ??
      information?.card?.content?.sections ??
      [];

    const payload = {
      ...topLevel,
      card: cardObj,
      content: { sections: contentSections },
    };

    return {
      ...sharedPayload,
      data: payload,
      template: "standard",
      title: sharedPayload.title || "* Standard Content Title *",
      group: 1,
    };
  }

  if (template?.toLowerCase() === "banner" || type === "Banner") {
    let parsedData = {};
    if (typeof data === "string") {
      try {
        parsedData = JSON.parse(data);
      } catch (err) {
        console.error("Invalid JSON in banner data:", err);
      }
    } else if (typeof data === "object" && data !== null) {
      parsedData = data;
    }

    return {
      ...sharedPayload,
      data: {
        // Accept multiple possible field names from the form: link, img, image, align/position
        link: parsedData.link ?? information?.link ?? "",
        image:
          parsedData.image ??
          information?.card?.image ??
          information?.imgSrc ??
          information?.img ??
          "",
        position:
          parsedData.position ??
          information?.position ??
          information?.align ??
          "center",
      },
      template: "banner",
      title: sharedPayload.title || "* Banner Title *",
      group: 2,
    };
  }

  throw new Error(`Unsupported feedItem type: ${type}`);
}
